__turbopack_context__.v({
  "timestamp": "Timestamp-module-scss-module__wg8Viq__timestamp",
});
